import { useApp } from './AppProvider.tsx';
import { useLocation } from 'react-router-dom';

export type AppLocationState = {
  isHome: boolean;
  isFollowing: boolean;
  isPhotos: boolean;
  isAwards: boolean;
  isLeaderboard: boolean;
  isDetails: boolean;
  isProgress: boolean;
  isStatistics: boolean;
  isCertificatePreview: boolean;
};

const useAppLocation = (): AppLocationState => {
  const location = useLocation();
  const [{ event }] = useApp();
  const { uniqueCode: eventUniqueCode = '' } = event || {};
  const { pathname } = location;

  const isHome = pathname.match(new RegExp(`events/${eventUniqueCode}(?:/)?(?:\\?.*)?$`)) !== null;
  const isFollowing =
    pathname.match(new RegExp(`events/${eventUniqueCode}/following(?:/)?(?:\\?.*)?$`)) !== null;
  const isPhotos =
    pathname.match(new RegExp(`events/${eventUniqueCode}/photos(?:/)?(?:\\?.*)?$`)) !== null;
  const isAwards =
    pathname.match(new RegExp(`events/${eventUniqueCode}/race/.+/awards(?:\\?.*)?$`)) !== null;
  const isLeaderboard =
    pathname.match(new RegExp(`events/${eventUniqueCode}/race/\\d+(?:/)?(?:\\?.*)?$`)) !== null;
  const isDetails =
    pathname.match(new RegExp(`events/${eventUniqueCode}/race/\\d+/participant/.+(?:\\?.*)?$`)) !==
    null;
  const isProgress =
    pathname.match(new RegExp(`events/${eventUniqueCode}/progress(?:/)?$`)) !== null;
  const isStatistics =
    pathname.match(new RegExp(`events/${eventUniqueCode}/race/\\d+/statistics(?:\\?.*)?$`)) !==
    null;
  const isCertificatePreview =
    pathname.match(new RegExp(`events/${eventUniqueCode}/finisher-certificate`)) !== null;

  return {
    isHome,
    isFollowing,
    isPhotos,
    isAwards,
    isLeaderboard,
    isDetails,
    isProgress,
    isStatistics,
    isCertificatePreview,
  };
};

export default useAppLocation;
